import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {AuthService} from '../../../../../applications/securite/service/auth.service';

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";

  constructor(public router: Router,
              public authservice: AuthService) {
    if (JSON.parse(localStorage.getItem("user"))) {
    } else {
    }
  }

  ngOnInit() {}
  navigateToProfile() {
    this.router.navigate(['/secu','compte']);
    // this.router.navigate(['accueil','']);
    // this.router.navigate(['/structure','view']);

  }
  logoutFunc() {
    this.authservice.signOut();
    this.router.navigateByUrl('auth/login');
  }
}
